import React from 'react';
import './Hero.css';

const Hero = () => {
  return (
    <section id="home" className="hero">
      <div className="hero-overlay"></div>
      <div className="hero-content">
        <div className="container">
          <div className="hero-text">
            <span className="hero-label">ORION BILLING SYSTEM</span>
            <h1 className="hero-title">
              Smart <span className="gradient-text">Billing & Invoice</span> Management System
            </h1>
            <p className="hero-description">
              Kelola invoice, tagihan, dan pembayaran pelanggan dengan mudah dan otomatis. 
              Sistem billing modern untuk bisnis yang ingin meningkatkan efisiensi dan cash flow.
            </p>
            <div className="hero-buttons">
              <a href="#solutions" className="btn-primary">Lihat Fitur</a>
              <a href="#contact" className="btn-secondary">Coba Gratis</a>
            </div>
            <div className="hero-stats">
              <div className="stat-item">
                <h3>99.9%</h3>
                <p>Uptime SLA</p>
              </div>
              <div className="stat-item">
                <h3>500+</h3>
                <p>Active Users</p>
              </div>
              <div className="stat-item">
                <h3>24/7</h3>
                <p>Support</p>
              </div>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
};

export default Hero;
